import { Field } from "formik";
import React, { useState, useRef } from "react";

const TextAreaInput = ({
  name,
  value,
  handleChange,
  placeholder,
  isDisabled = false,
  bgColor = "bg-gray-50",
  classes = "",
  rows = 4,
  legend = false
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const textareaRef = useRef(null);

  const handleFieldsetClick = () => {
    if (!isFocused && !value) {
      textareaRef.current.focus();
    }
  };

  return legend ? (
    <fieldset
      className={`relative border ${isFocused ? "border-primary" : "border-gray-500"} border-gray-300 rounded-md w-full border-2 px-2 pt-2 pb-1`}
      onClick={handleFieldsetClick}
    >
      <legend
        className={`absolute left-2 transition-all duration-200 ${bgColor} px-1 ${
          isFocused || value
            ? "-top-3 text-sm text-primary"
            : "top-3 text-sm text-gray-400"
        }`}
      >
        {placeholder}
      </legend>

      <Field
        as="textarea"
        name={name}
        value={value}
        onChange={handleChange}
        disabled={isDisabled}
        rows={rows}
        className={`${classes} w-full border-none outline-none bg-transparent resize-none pt-1 px-2 h-12`}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        innerRef={textareaRef}
      />
    </fieldset>
  ) : (
    <Field
      as="textarea"
      name={name}
      value={value}
      onChange={handleChange}
      disabled={isDisabled}
      rows={rows}
      placeholder={placeholder}
      className={`${classes} w-64 border border-gray-300 rounded-[0.3rem] p-2 resize-none`}
    />
  );
};

export default TextAreaInput;
